import React from "react";
import PropTypes from "prop-types";
import { cropNumber } from "../../../../common/helpers/helpers";
import VersionText from "../../../../components/atoms/VersionText";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { eveScoresType } from "./types/types";

const { string } = PropTypes;

const EveScore = ({ eveScores, databaseUrl, name, version, subTextUrl }) => {
  if (!eveScores.flat().length) return null;

  return (
    <tr key="evescore-row" className="dbnsfp-row">
      <td width="20%">
        {databaseUrl ? (
          <a href={databaseUrl} target="_blank">
            {name}
          </a>
        ) : (
          `${name} `
        )}
        <br />
        <VersionText
          anchorUrl={subTextUrl}
          anchorText="eveDB"
          versionText={version}
        />
      </td>
      <td>
        <div className="varsome-horiz-list-label varsome-dbnsfp-label">
          prediction
        </div>

        <div className="varsome-horiz-list-value">
          {eveScores.map((arr, index) =>
            arr.map((elem) =>
              index === eveScores.length - 1 ? (
                <span
                  key={`${elem.class_75}-${index}-pred`}
                  style={{
                    color: getPathogenicityColorByAllNames(elem.class_75),
                  }}
                >
                  {elem.class_75}
                </span>
              ) : (
                <span
                  key={`${elem.class_75}-${index}-pred`}
                  style={{
                    color: getPathogenicityColorByAllNames(elem.class_75),
                  }}
                >
                  {elem.class_75},{" "}
                </span>
              )
            )
          )}
        </div>
      </td>
      <td>
        <div className="varsome-horiz-list-label varsome-dbnsfp-label">
          score
        </div>
        <div className="varsome-horiz-list-value">
          {eveScores.map((arr, index) =>
            arr.map((elem) =>
              index === eveScores.length - 1 ? (
                <span
                  key={`${elem.class_75}-${index}-${elem.eve_score}`}
                  style={{
                    color: getPathogenicityColorByAllNames(elem.class_75),
                  }}
                >
                  {cropNumber(elem.eve_score)}
                </span>
              ) : (
                <span
                  key={`${elem.class_75}-${index}-${elem.eve_score}`}
                  style={{
                    color: getPathogenicityColorByAllNames(elem.class_75),
                  }}
                >
                  {cropNumber(elem.eve_score)},{" "}
                </span>
              )
            )
          )}
        </div>
      </td>
    </tr>
  );
};

EveScore.propTypes = {
  eveScores: eveScoresType,
  databaseUrl: string,
  name: string,
  version: string,
  subTextUrl: string,
};

EveScore.defaultProps = {
  eveScores: [],
  databaseUrl: "",
  name: "",
  version: "",
  subTextUrl: "",
};

export default EveScore;
